import axios from 'axios';


export const subscribeToNewsletter = ({
  submitUrl,
  payload,
  csrfToken,
  onError,
}) => {
  axios
    .post(submitUrl, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      }
    })
    .catch(onError);
};
